/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-loop-func */
import { sort } from "./Sort";

const fertMonthAbbrs: any = [
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
];

const calMonthAbbrs: any = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatByCalendarType = (
  data: any[],
  config: {
    calendarFormat: "cal" | "fert";
    property: string;
    startYear: number;
    endYear: number;
  }
) => {
  const newRows: any[] = [];

  const entityGroups = data.reduce((acc, r) => {
    const key = r[config.property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(r);
    return acc;
  }, {});

  Object.keys(entityGroups).forEach((entityKey) => {
    const entityGroup = entityGroups[entityKey];

    const groups = entityGroup.reduce((acc: any, r: any) => {
      let year = r.year as number;
      if (config.calendarFormat === "fert" && r.month < 7) {
        year -= 1;
      }

      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(r);
      return acc;
    }, {});

    const years: any = {};
    years[`${Number(config.endYear) - 4}`] = "year1";
    years[`${Number(config.endYear) - 3}`] = "year2";
    years[`${Number(config.endYear) - 2}`] = "year3";
    years[`${Number(config.endYear) - 1}`] = "year4";
    years[`${Number(config.endYear)}`] = "year5";

    const newRow = {
      year1: 0,
      year2: 0,
      year3: 0,
      year4: 0,
      year5: 0,
    };
    (newRow as any)[config.property] = entityKey;

    sort(Object.keys(groups), "ASC").forEach((yearKey) => {
      const yearGroup: any = groups[yearKey];

      const sumQuantity = yearGroup.reduce(
        (acc: any, r: any) => acc + r.quantity32e,
        0
      );

      (newRow as any)[years[yearKey]] = sumQuantity;
    });

    newRows.push(newRow);
  });

  return newRows;
};

export const calendarTypeOrder = (
  data: { year: number; month: number; quantity32e: number }[],
  config: {
    calendarFormat: "cal" | "fert";
    property: string;
    startYear: number;
    endYear: number;
  }
) => {
  let currentYear = config.startYear;
  let currentMonth = config.calendarFormat === "fert" ? 7 : 1;

  const newRows: any[] = [];
  for (let i = 0; i < 60; i += 1) {
    const record = data.find((r) => {
      return r.year === currentYear && r.month === currentMonth;
    });

    newRows.push({
      year: currentYear,
      month: currentMonth,
      quantity32e: record?.quantity32e || 0,
    });

    currentMonth += 1;
    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear += 1;
    }
  }

  if (config.calendarFormat === "fert") {
    newRows.forEach((row) => {
      if (row.month < 7) {
        row.year -= 1;
      }

      let newMonth = row.month - 6;
      if (newMonth <= 0) {
        newMonth += 12;
      }
      row.month = newMonth;
    });
  }

  const groups = newRows.reduce((acc, r) => {
    if (!acc[r.month]) {
      acc[r.month] = [];
    }
    acc[r.month].push(r);
    return acc;
  }, {});

  const records: any[] = [];
  Object.keys(groups).forEach((key) => {
    const group: any[] = groups[key];

    records.push({
      month:
        config.calendarFormat === "fert"
          ? fertMonthAbbrs[Number(key) - 1]
          : calMonthAbbrs[Number(key) - 1],
      year1: group.find((r) => r.year === config.endYear - 4)?.quantity32e || 0,
      year2: group.find((r) => r.year === config.endYear - 3)?.quantity32e || 0,
      year3: group.find((r) => r.year === config.endYear - 2)?.quantity32e || 0,
      year4: group.find((r) => r.year === config.endYear - 1)?.quantity32e || 0,
      year5: group.find((r) => r.year === config.endYear)?.quantity32e || 0,
    });
  });

  return records;
};

export const getAdjustedYears = (endYear: number, calendarType: string) => {
  const years = [endYear - 4, endYear - 3, endYear - 2, endYear - 1, endYear];

  if (calendarType === "fert") {
    return years.map((y) => y + 1);
  }

  return years;
};
